import React from 'react';
import ResultItem from '../items/ResultItem';

function SearchResponse({ announcements, onClose }) {
    const limited = announcements.slice(0, 10);

    return (
        <div className="p-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
            {limited.map((item, i) => (
                <ResultItem
                    key={item.id || i}
                    title={item.title}
                    categoryName={item.category}
                    subCategoryName={item.subCategory}
                    categoryId={item.categoryId}
                    subCategoryId={item.subCategoryId}
                    location={item.location?.locality || item.location?.province || ''}
                    onClose={onClose}
                />
            ))}
        </div>
    );
}

export default SearchResponse;
